var Locales;
(function(Locales) {
    Locales['en-IO'] = 'en-IO';
    Locales['ca-ES'] = 'ca-ES';
    Locales['da-DK'] = 'da-DK';
    Locales['en-GB'] = 'en-GB';
    Locales['es-ES'] = 'es-ES';
    Locales['fr-BE'] = 'fr-BE';
    Locales['it-IT'] = 'it-IT';
    Locales['nl-BE'] = 'nl-BE';
    Locales['nl-NL'] = 'nl-NL';
    Locales['pt-PT'] = 'pt-PT';
    Locales['sv-SE'] = 'sv-SE';
    Locales['en-IE'] = 'en-IE';
    Locales['fr-FR'] = 'fr-FR';
    Locales['de-DE'] = 'de-DE';
    Locales['de-AT'] = 'de-AT';
})(Locales || (Locales = {}));
var Countries;
(function(Countries) {
    Countries["BE"] = "BE";
    Countries["DK"] = "DK";
    Countries["ES"] = "ES";
    Countries["GB"] = "GB";
    Countries["IO"] = "IO";
    Countries["IT"] = "IT";
    Countries["NL"] = "NL";
    Countries["PT"] = "PT";
    Countries["SE"] = "SE";
    Countries["IE"] = "IE";
    Countries["FR"] = "FR";
    Countries["DE"] = "DE";
    Countries["AT"] = "AT";
    Countries["BG"] = "BG";
    Countries["HR"] = "HR";
    Countries["CY"] = "CY";
    Countries["CZ"] = "CZ";
    Countries["EE"] = "EE";
    Countries["FI"] = "FI";
    Countries["GR"] = "GR";
    Countries["HU"] = "HU";
    Countries["LU"] = "LU";
    Countries["LV"] = "LV";
    Countries["LT"] = "LT";
    Countries["MT"] = "MT";
    Countries["PL"] = "PL";
    Countries["SK"] = "SK";
    Countries["SI"] = "SI";
    Countries["RO"] = "RO";
})(Countries || (Countries = {}));
var Currencies;
(function(Currencies) {
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["USD"] = "USD";
    Currencies["SEK"] = "SEK";
    Currencies["DKK"] = "DKK";
})(Currencies || (Currencies = {}));
var Regions;
(function(Regions) {
    Regions['EU'] = 'EU';
    Regions['US'] = 'US';
})(Regions || (Regions = {}));

export { Countries, Currencies, Locales, Regions };
//# sourceMappingURL=intl.js.map
